import React, { Component } from 'react';
import './calculator.scss';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as budgetActions from '../../actions/budgetActions';
import * as lineItemActions from '../../actions/lineItemActions';
import * as mandatoriesActions from '../../actions/mandatoriesActions';
import MandatoriesContainer from '../mandatories/MandatoriesContainer';
import StepContainer from '../step/StepContainer';
import {Link} from 'react-router-dom';


class BudgetContainer extends Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			lineItemElements: []
		}
		this.initBudgetLineItems();
		this.openItem = this.openItem.bind(this);
		this.moveToItem = this.moveToItem.bind(this);
	
	}


	initBudgetLineItems() {
		if(this.props.selectedBudget) {
			const currentBudget = this.props.budgets.filter(e => {
				if(e.id === this.props.selectedBudget)
					return e;
			});
			
			if(currentBudget !== null) 
				this.loadLineItems(this.props.itemRepository, currentBudget[0].lines);
			

		}
	}

	componentDidUpdate(prevProps, prevState) {
		this.initBudgetLineItems();
	}

	loadLineItems(itemRepo, reqItems) {
		reqItems.forEach(line => {
			var k = 'li' + line.id;
			if(itemRepo[k] === undefined)
				this.props.actions.loadBudgetLineItem(line.id)
		});
	}

	moveToItem() {
		const currentItem = this.props.mandatories.currentLine;
		const lines = this.getCurrentBudgetLineItems();
		if(currentItem === 0) {
			this.props.mandatoriesActions.moveToLineItem('li' + lines[0].id);
		} else {
			const finalItem = lines.length-1;
			lines.forEach((line, index) => {
				if("li" + line.id === currentItem) {
					if(index < finalItem) {
						this.props.mandatoriesActions.moveToLineItem("li" + lines[index+1].id);
					} else {
						// There are no more itmes to display?>?
					}
				}
			})
		}

	}

	openItem(id) {
		this.props.mandatoriesActions.moveToLineItem(id);
	}

	getCurrentBudgetLineItems() {
		// Create a shorthand method to access the lines of this budget
		return this.props.budgets.filter(e => {
			if(e.id === this.props.selectedBudget)
				return e;
		})[0].lines;
	}

	getCurrentBudgetName() {
		// Create a shorthand method to access the Name of the budget
		return this.props.budgets.filter(e => {
			if(e.id === this.props.selectedBudget)
				return e;
		})[0].title;
	}

  render() {
		// Create a shorthand method to access the lines of this budget
		const lines = this.getCurrentBudgetLineItems();
    return (
      <div className="calculator-steps-wrapper">
				<MandatoriesContainer nextItem={this.moveToItem} open={this.props.mandatories.currentLine === 0} openItem={this.openItem} />
				{lines.map((line, index) => {
					var k = 'li' + line.id;
					if(this.props.itemRepository[k] !== undefined) {
						const item = this.props.itemRepository[k]
						if(item.status && item.status === 'pending') {
							// render pending elem
						} else {
							return <StepContainer 
								key={k} 
								group={item} 
								open={this.props.mandatories.currentLine === k} 
								nextItem={this.moveToItem} 
								openItem={this.openItem} 
								id={k} 
								displayNextButton={index !== lines.length-1} />
						}
					}
				})}

				<section className='estimate'>
					<div className='row'>
						<div className='col center'>
								{/* <a className="btn large" onClick={this.handleGetEstimate}>Get Estimate</a> */}
								<Link to='estimate' className="btn large" >Get Estimate</Link>
						</div>
					</div>
				</section>
        
			</div>
			
    );
  }
}


const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		budgetActions: bindActionCreators(budgetActions, dispatch),
		actions: bindActionCreators(lineItemActions, dispatch),
		mandatoriesActions: bindActionCreators(mandatoriesActions, dispatch)
	};
}

const mapStateToProps = (state, ownProps) => {

	// let mostFavoriteIds = state.user.FavoriteLocations.filter(loc => loc.IsMostFavorite).map(mostFav => mostFav.RestaurantId);
	// let immutableRestaurants = [...state.restaurants].map((restaurant) => {
	// 	return Object.assign({}, restaurant, { IsMostFavorite: mostFavoriteIds.indexOf(restaurant.Id) > -1 });
	// });

	// immutableRestaurants.sort((rA, rB) => {
	// 	let nameA = rA.Title.toUpperCase(); // ignore upper and lowercase
	// 	let nameB = rB.Title.toUpperCase(); // ignore upper and lowercase
	// 	if (rA.IsMostFavorite ^ rB.IsMostFavorite) {
	// 		return rA.IsMostFavorite ? -1 : 1; // mostFavoriteRestaurant should be closer to the beginning of the list
	// 	} else {
	// 		if (nameA < nameB) return -1;
	// 		if (nameA > nameB) return 1;
	// 		return 0;
	// 	}
	// });

	return {
		budgets: state.budgets,
		itemRepository: state.lineItems,
		mandatories: state.mandatories,
		estimates: state.estimates
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(BudgetContainer);



// WEBPACK FOOTER //
// ./src/components/calculator/BudgetContainer.js